import {
    action,
    computed,
    observable
} from 'mobx';

export interface IAuthorisationStore {
    readonly isTokenValid: boolean;
    readonly authorisationToken: string | null;

    expireToken(): void;
    acceptToken(token: string): void;
    resetToken(): void;
}

export class AuthorisationStore implements IAuthorisationStore {
    @observable
    private hasValidToken: boolean = false;
    @observable
    private authToken: string | null = null;

    @computed
    get isTokenValid(): boolean {
        return this.hasValidToken;
    }

    @computed
    get authorisationToken(): string | null {
        return this.authToken;
    }

    @action
    public expireToken() {
        this.hasValidToken = false;
    }

    @action
    public acceptToken(token: string) {
        this.authToken = token;
        this.hasValidToken = true;
    }

    @action
    public resetToken() {
        this.expireToken();
        this.authToken = null;
    }
}

export default AuthorisationStore;



// WEBPACK FOOTER //
// ./src/stores/authorisation/authorisation-store.ts